import React from "react";
import Header from "../../Header1";
import Footer from "../../Footer2";
import Title from "./Title";
import Form from "./Form";

const ContactOne = () => {
	return (
		<>
			<Header />
			<Form />
			<Footer />
		</>
	);
};
export default ContactOne;
